import { render } from "./DisabledField.vue?vue&type=template&id=8750aa80"
import script from "./DisabledField.vue?vue&type=script&lang=js"
export * from "./DisabledField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__